export function getAll() {
  return [
    {
      value: 0,
      name: "Big",
      text: "大（預設）",
    },
    {
      value: 1,
      name: "Standard",
      text: "中",
    },
    {
      value: 2,
      name: "Small",
      text: "小",
    },
  ];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}

export function getByType(type) {
  const types = getAll().filter(function (item) {
    return item.type == type;
  });
  return types;
}
